import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

import { LegalAssistanceRequestsSectionSkeleton } from './components/legal-assistance-requests-section-skeleton.tsx'

/** Pending placeholder for the Legal assistance screen — shares the View frame with the real content. */
export function LegalAssistancePageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={280} height={32} />
        </View.Header>
        <View.Body>
          <LegalAssistanceRequestsSectionSkeleton />
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
